import React from 'react';
import PropTypes from 'prop-types';
import { EnvironmentFilled } from '@ant-design/icons';

const GoogleMapPin = ({ info }) => (
  <div className="pin">
    <EnvironmentFilled className="pin-icon" />
    <p className="pin-info">{info}</p>
  </div>
);

GoogleMapPin.propTypes = {
  info: PropTypes.string.isRequired
};

export default GoogleMapPin;
